export enum TestViews {
  START_VIEW = 'start',
  TESTS_VIEW = 'tests',
  ANSWERS_VIEW = 'answers',
  TEST_RESULT = 'result',
}

export const SCROLLABLE_QUESTION_CONTAINER_ID = 'scrollable';
